// 販売店用共通関数
/**
 * 販売店情報一覧画面に遷移
 * @return void
 */
export var navigationToStoreLint = function () {
    location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/store/list" + location.search;
};
/**
 * NO販売店情報一覧画面に遷移
 * @return void
 */
export var navigationToNoStoreLint = function () {
    location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/list";
};
